import { Text } from '#app/components/Primitives/Text.js';
import { styled } from 'styled-components';

export const ProfileContainer = styled.div`
  &,
  & > a {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const BadgesAndName = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const Badges = styled.div`
  display: flex;
  gap: 6px;
`;

export const Name = styled(Text)`
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
  letter-spacing: -0.15px;
`;
